module.exports = {"width":302,"height":201,"type":"png"}